module.exports = __webpack_public_path__ + "img/pappers.9867de9b.png";